'use client';

import React, { useContext } from 'react';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import { productContext } from '../products/productContext';
import H200 from './products/H200';
import B200 from './products/B200';
import Storage from './products/Storage';
import ObjectStorage from './products/ObjectStorage';
import Kubernetes from './products/Kubernetes';
import Observability from './products/Observability';
import DataSync from './products/DataSync';

import { 
  productSelectedOptionClassName,
  productContentClassName,
  productListClassName,
  productItemClassName
 } from './Styles';

export default function Product() {
  const {
    i18nHelper: { t },
  } = useGlobalClientContext();


  const {
      selectedProduct,
      setSelectedProduct,
    } = useContext(productContext);

  return (
    <div className={productContentClassName}>
      <hr className="border-gray-200 m-0 w-full" />
      <div className={productListClassName}>
          <div className={productItemClassName}>
            <span 
              className={`px-s ${selectedProduct === 'H200' ? productSelectedOptionClassName : ''}`} 
              onClick={() => setSelectedProduct('H200')}
            >
              {t('public.site.products.product.h200', {})}
            </span>
            <span 
              className={`px-s ${selectedProduct === 'B200' ? productSelectedOptionClassName : ''}`} 
              onClick={() => setSelectedProduct('B200')}
            >
              {t('public.site.products.product.b200', {})}
            </span>
            <span 
              className={`px-s ${selectedProduct === 'storage' ? productSelectedOptionClassName : ''}`} 
              onClick={() => setSelectedProduct('storage')}>
              {t('public.site.products.product.storage', {})}
            </span>
            <span 
              className={`px-s ${selectedProduct === 'Kubernetes' ? productSelectedOptionClassName : ''}`} 
              onClick={() => setSelectedProduct('Kubernetes')}>
              {t('public.site.products.product.kubernetes', {})}
            </span>
            <span 
              className={`px-s ${selectedProduct === 'Observability' ? productSelectedOptionClassName : ''}`} 
              onClick={() => setSelectedProduct('Observability')}>
              {t('public.site.products.product.observability', {})}
            </span>
            <span 
              className={`px-s ${selectedProduct === 'objectStorage' ? productSelectedOptionClassName : ''}`} 
              onClick={() => setSelectedProduct('objectStorage')}>
              {t('public.site.products.product.objectStorage', {})}
            </span>
            <span 
              className={`px-s ${selectedProduct === 'dataSync' ? productSelectedOptionClassName : ''}`} 
              onClick={() => setSelectedProduct('dataSync')}>
              {t('public.site.products.product.dataSync', {})}
            </span>
          </div>
      </div>
      {/* Product details */}
      {selectedProduct === 'H200' && <H200 />}
      {selectedProduct === 'B200' && <B200 />}
      {selectedProduct === 'storage' && <Storage />}
      {selectedProduct === 'Kubernetes' && <Kubernetes />}
      {selectedProduct === 'Observability' && <Observability />}
      {selectedProduct === 'objectStorage' && <ObjectStorage />}
      {selectedProduct === 'dataSync' && <DataSync />}
    </div>
  );
}
